const SearchBar: React.FC<{
  placeHolderText: string;
  searchValue: string;
  onSearchChange: any;
  hasCreate: boolean;
  createTitle: string;
  onCreate: any;
  count: number;
  countType: string;
  isEmbedded?: boolean;
  searchSideContent?: any | undefined;
}> = ({
  placeHolderText,
  searchValue,
  onSearchChange,
  hasCreate,
  createTitle,
  onCreate,
  count,
  countType,
  isEmbedded = false,
  searchSideContent = undefined,
}) => {
  return (
    <div className={isEmbedded ? "" : "card-body"}>
      <div className="row align-items-center justify-content-between">
        <div className="col-auto">
          <div className="row align-items-center">
            <div className="col">
              <form className="search-form">
                <i className="bi bi-search search-icon"></i>
                <input
                  type="search"
                  name="q"
                  placeholder={placeHolderText}
                  autoComplete="off"
                  value={searchValue}
                  onChange={onSearchChange}
                />
              </form>
            </div>
            <div className="col">
              {searchSideContent && <>{searchSideContent}</>}
            </div>
          </div>
        </div>
        <div className="col-auto ms-auto">
          <div className="d-flex flex-column align-items-end">
            {hasCreate && (
              <>
                <button className="btn btn-primary" onClick={() => onCreate()}>
                  <i className="bi bi-plus-lg me-1"></i> {createTitle}
                </button>
              </>
            )}
            <div
              style={{
                visibility: count > 0 ? "visible" : "hidden",
              }}
            >{`${count} ${countType}`}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchBar;
